import { VueRenderer } from '@tiptap/vue-2';
import tippy from 'tippy.js';
import axios from 'axios';
import HashtagsList from './HashtagsList.vue';

export default {
    name: 'HashtagSuggestion',
    items: async ({ query }) => {
        if (!query) {
            return [];
        }

        const result = [];
        await axios({
            method: 'GET',
            url: `/tags/search?term=${query}`,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response && response.data) {
                    let tagForQueryNotExist = true;
                    response.data.forEach((entry) => {
                        if (entry.Slug === query.toLowerCase()) {
                            tagForQueryNotExist = false;
                            result.unshift({
                                name: entry.Slug,
                                slug: entry.Slug,
                                id: entry.ID,
                            });
                        } else {
                            result.push({
                                name: entry.Slug,
                                slug: entry.Slug,
                                id: entry.ID,
                            });
                        }
                    });

                    if (tagForQueryNotExist) {
                        result.unshift({
                            name: query,
                            slug: query,
                            id: query,
                        });
                    }
                } else {
                    result.unshift({
                        name: query,
                        slug: query,
                        id: query,
                    });
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 404) {
                    result.unshift({
                        name: query,
                        slug: query,
                        id: query,
                    });
                } else {
                    console.log(error);
                }
            });
        return result;
    },

    render: () => {
        let component;
        let popup;
        let lastProps = null;
        let shouldInsertOnExit = true;

        const decorateProps = (props) => {
            lastProps = props;
            const originalCommand = props.command;

            return {
                ...props,
                command: (attributes) => {
                    shouldInsertOnExit = false;
                    return originalCommand(attributes);
                },
            };
        };

        return {
            onStart: (props) => {
                shouldInsertOnExit = true;
                const decoratedProps = decorateProps(props);

                component = new VueRenderer(HashtagsList, {
                    // using vue 2:
                    parent: this,
                    propsData: decoratedProps,
                    // props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                    zIndex: 2147484000, // make sure this is above modals. CoModal has z-index :2147483000
                });
            },

            onUpdate(props) {
                const decoratedProps = decorateProps(props);
                component.updateProps(decoratedProps);

                if (!props.clientRect) {
                    return;
                }

                if (popup && popup[0]) {
                    popup[0].setProps({
                        getReferenceClientRect: props.clientRect,
                    });
                }
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    shouldInsertOnExit = false;
                    if (popup && popup[0]) {
                        popup[0].hide();
                    }

                    return true;
                }

                return component && component.ref && component.ref.onKeyDown ? component.ref.onKeyDown(props) : false;
            },

            onExit() {
                if (popup && popup[0]) {
                    popup[0].destroy();
                }
                if (component) {
                    component.destroy();
                }

                if (
                    shouldInsertOnExit &&
                    lastProps &&
                    typeof lastProps.query === 'string' &&
                    lastProps.query.trim().length &&
                    typeof lastProps.command === 'function'
                ) {
                    const query = lastProps.query.trim();
                    shouldInsertOnExit = false;
                    lastProps.command({
                        id: query,
                        label: query,
                    });
                }
            },

            command({ editor, range, props }) {
                console.log('command', editor, range, props);
            },
        };
    },
};
